const asBoolean = (value) => {
  if (value === true || value === 1 || value === "1" || String(value).toLowerCase() === "true") {
    return true;
  }
  if (value === false || value === 0 || value === "0" || String(value).toLowerCase() === "false") {
    return false;
  }
  return null;
};

/**
 * A saved phone number as the app should show it, and whether it is on the
 * Do Not Call registry.
 *
 * Saved numbers carry a legacy marker that reads the wrong way round: a
 * leading "*" means NOT on the registry (formatStoredPhoneContact in the
 * backend). Showing it raw under "an asterisk indicates DNC" told customers
 * the opposite of the truth. An explicit is_dnc wins when the record has one;
 * otherwise the marker decides. That is the rule formatExportPhoneContact
 * applies to the export file, so the screen and the file always agree.
 *
 * @param {string|{number?: string, type?: string, is_dnc?: unknown, dnc?: unknown}} contact
 * @returns {{number: string, type: string|null, isDnc: boolean}}
 */
export function phoneDncStatus(contact) {
  const record = typeof contact === "object" && contact !== null ? contact : { number: contact };
  const raw = String(record.number ?? "").trim();
  const starred = raw.startsWith("*");

  const explicit = asBoolean(record.is_dnc) ?? asBoolean(record.dnc);

  return {
    number: starred ? raw.slice(1).trim() : raw,
    type: record.type || null,
    isDnc: explicit ?? !starred,
  };
}
